import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {CategorizedActionsSelect} from "../../selects/CategorizedActionsSelect";
import {CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import {withTranslation} from 'react-i18next';


class ConfigureEventsStepClass extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allActions: null,
            selectedActions: this.props.initialSelectedActions || [],
            isSaving: false
        };

        this.handleActionsChange = this.handleActionsChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.loadActions();
    }

    loadActions() {
        const url = `${API_URL}agency/ad-accounts/${this.props.adAccountDbId}/actions`;
        new APIClient(url).call('GET').then((response) => {
            if (response.status === 'OK') {
                if (response.data.length === 0) {
                    this.props.onSkip();
                } else {
                    this.setState({allActions: response.data});
                }
            } else {
                this.props.onSkip();
            }
        }).catch(() => {
            this.props.onSkip();
        });
    }

    handleActionsChange(actionIds) {
        this.setState({selectedActions: actionIds});
    }

    handleSave() {
        this.setState({isSaving: true});
        this.props.onSave(this.state.selectedActions);
    }

    renderLoading() {
        return (
            <ModalBody>
                <div className="modal-section" style={{textAlign: 'center', padding: '3em 2em'}}>
                    <Spinner color="positive"/>
                </div>
            </ModalBody>
        );
    }

    renderActionsSelect() {
        const {t, channel} = this.props;
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];

        return (
            <React.Fragment>
                <ModalBody>
                    <div className="modal-section configure-events-step">
                        <div className="invite-info-callout" style={{marginBottom: '1em'}}>
                            <p>{t('configure_events.info_text')}</p>
                        </div>
                        <label className="form-label">{t('configure_events.select_label')}</label>
                        <CategorizedActionsSelect
                            items={this.state.allActions}
                            selectedItemIds={this.state.selectedActions}
                            onChange={this.handleActionsChange}
                            itemDataMap={(item) => ({
                                name: item.name || item.description,
                                id: item.action_id,
                            })}
                            hasAllPrimaryConversionsOption={channelInfo.hasIncludeAllConversionsSetting}
                            channel={channel}
                        />
                        <p className="text-muted" style={{fontSize: '0.85em', marginTop: '0.5em'}}>
                            {t('configure_events.default_info')}
                        </p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn -negative" onClick={this.props.onSkip}>
                        {this.props.cancelLabel || t('configure_events.skip')}
                    </button>
                    {this.state.isSaving
                        ? <Spinner color="positive small"/>
                        : <button type="button" className="btn -alt" onClick={this.handleSave}>
                            {t('configure_events.save')}
                        </button>
                    }
                </ModalFooter>
            </React.Fragment>
        );
    }

    render() {
        if (this.state.allActions === null) {
            return this.renderLoading();
        }

        return this.renderActionsSelect();
    }
}

export const ConfigureEventsStep = withTranslation()(ConfigureEventsStepClass);
export default ConfigureEventsStep;
